<template>
  <PageLayoutWrapper
    page="courses/index"
  >
    <DefaultCoursesView :page-content="pageContent" />
  </PageLayoutWrapper>
</template>

<script>
import { mapGetters } from 'vuex'
import DefaultCoursesView from '@/components/DefaultCoursesView'
import pageLayout from '@/mixins/pageLayoutMixin'
import PageLayoutWrapper from '@/components/PageLayoutWrapper'
import { metaTags, metaTitle } from '@/utils/meta'
import useMeta from '@/composables/useMeta'

export default {
  components: { DefaultCoursesView, PageLayoutWrapper },
  mixins: [pageLayout],
  setup() {
    const { catalogWideMetaTitle } = useMeta()
    return { catalogWideMetaTitle }
  },
  computed: {
    ...mapGetters('settings', ['layout']),
    pageContent() {
      return this.$route.query.preview
        ? this.page?.temporaryContent
        : this.page?.content
    },
  },
  async asyncData({ $axios, $bugsnag, redirect, store }) {
    const url = `/ca/${store.state.settings.school}/catalogPages/${
      store.state.settings.activeCatalog
    }/courses`

    try {
      const [page, { terms }, { semesterNames }] = await Promise.all([
        $axios.$get(url),
        $axios.$get(`/${store.state.settings.school}/general/terms`),
        $axios.$get(`/${store.state.settings.school}/general/semesterNames`),
      ])
      return {
        page,
        terms,
        semesterNames,
      }
    } catch (e) {
      // 404 status (with {} response body) is an expected response here, if the courses pre-built page is not present in the catalog
      // (this page can be removed from catalog)
      // we don't want to pollute bugsnag with those errors
      if (e.response.status !== 404) {
        $bugsnag.notify(e)
      }
      return {
        page: null,
        terms: [],
        semesterNames: {},
      }
    }
  },
  head() {
    return {
      ...metaTitle(this.page?.metafields, this.catalogWideMetaTitle),
      meta: metaTags(this.page?.metafields),
    }
  },
  provide() {
    return {
      terms: this.terms,
      semesterNames: this.semesterNames,
    }
  },
}
</script>
